<template>
  <div class="tincan-select-flex">
	  <!-- <div class="deneme-1 width-30"> -->
    <v-select
		id="tincan_dropdown"	
      name="File Type"
      placeholder="Select File Type"
      v-model="temp_lesson.filetype"
      :options="file_types"
      class="width-90 tincan_dropdown"
      label="filetype"
      v-validate="'required'"
    >
    </v-select>
	 <b-button @click="chooseLessonFileType" squared variant="primary">Update</b-button>
    <span v-if="errors.first('File Type')" class="error-msg">{{
      errors.first("File Type")
    }}</span>
	</div>
  <!-- </div> -->
</template>
<script>
export default {
	props:{
		lesson:{
			required: true
		},
		file_types:{
			required: true
		}

	},
	
	data : function(){
		return{
			temp_lesson: null

		}
	},
	created : function(){
		if(this.lesson){
			this.temp_lesson = this.lesson
			if(!this.temp_lesson.filetype.filetype){
				this.temp_lesson.filetype.filetype = null
			}
		}
	},
	methods : {
		chooseLessonFileType(){
            var temp_lesson = this.temp_lesson
            temp_lesson.lesson_filetype_id = this.temp_lesson.filetype.id
        	// temp_lesson.lesson_filetype_id = temp_lesson.lesson_file_type.id

            this.$store.dispatch('editLesson', temp_lesson).then((res) => {
                console.log(res)
            }).catch((error) => {
                this.$snotify.error('Error from server');
            });

        }
	}
}
</script>
<style>
 .tincan-select-flex>.v-select,.tincan_dropdown input[type=search], .v-select input[type=search]:focus{
	border-radius: 0px;
    height: 28px;
    min-width: 150px;
}

.tincan-select-flex{
	display: flex;
	flex-direction: row;
	width: 100%;
	gap: 1rem;
	max-width: 200px !important
}
</style>


// WEBPACK FOOTER //
// src/components/sme/SharedViews/LessonTincanDropdown.vue